const clubs = `Academic Resource Center
Accessible Education Office (AEO)
Active Minds Student Chapter at CAMHS
Adams House Committee
Advocating Success for Kids
Alcohol and Other Drug Services
All House Committee
An Evening with Champions
Asian American Brotherhood
Asian American Dance Troupe (AADT)
Asian Baptist Student Koinonia
Asian Student Arts Project
Association of Black Harvard Women
Athlete Ally: Harvard College Chapter
Australian Undergraduate Society at Harvard College (AUS)
Bach Society Orchestra
Bengali Association of Students at Harvard
Black Community and Student Theater
Brattle Street Chamber Players
Cabot House Committee
Cambridge Queen's Head
Camp Kesem Harvard Undergraduate
Catholic Student Association
Center for European Studies Student Society
Center for Wellness and Health Promotion 
Chinese Cultural Card Games Club
Christians on Campus
Circle of Women Harvard College
CityStep
Class Committee
Climbing Wall
Club Sports Office
College Events Board
Colombian Students Association at Harvard College
Common Spaces
Concilio Latino de Harvard
Constitutional Law Society
Contact Peer Counseling
Corcairdhearg: Harvard College Irish Dancers
Crimson After Dark
Crimson Dance Team
Crimson Key Society
CrimsonEMS
Currier House Committee
Dharma: Harvard's Hindu Students Association
Diversity Peer Educators 
Dudley Co-op
Dudley House Committee
Dunster House Committee
Eating Concerns Hotline and Outreach
Eleganza
Eliot House Committee
Eritrean and Ethiopian Students Association
European Business Group
Expressions Dance Company
Fall Clean-Up
Fallen Angels 
FIG. Magazine
First Year Retreat and Experience
First-Year Arts Program
First-Year International Program
First-Year Musical
First-Year Outdoor Program (FOP)
First-Year Social Committee
First-Year Urban Program
Food Literacy Project
Foundation for International Medical Relief of Children - Harvard College
Friends of Project Sunshine
Fuerza Latina
FUSIAN
Gender Inclusivity in Math
Generational African American Students Association
Green Medicine Initiative
Greener Scott Scholars Mentorship Program
Group for Undergraduate Students in Statistics at Harvard College
HAA Student-Alumni Engagement Committee
HackHarvardCollege
Harvard African Students Association
Harvard Aikikai Club
Harvard Anime Society
Harvard Archery Club
Harvard Association Cultivating Inter-American Democracy
Harvard Athletics Black Varsity Association
Harvard Badminton Club
Harvard Ballet Company
Harvard Ballroom Dance Team
Harvard Baseball Club
Harvard Basketball Club (Men's Classics)
Harvard Basketball Club (Men's Hoopsters)
Harvard Black Men's Forum
Harvard Black Students Association
Harvard Book Review 
Harvard Boxing Club
Harvard Breakers Organization
Harvard Broomball Club
Harvard Bulgarian Club
Harvard Canadian Club
Harvard Cancer Society
Harvard Caribbean Club
Harvard Cheerleading Club
Harvard Chemistry Club
Harvard Chess Club
Harvard Christian Impact
Harvard Classical Club
Harvard Climbing Club
Harvard College Act On A Dream Club
Harvard College Africa Business and Investment Club
Harvard College Albanian Students Association
Harvard College Anscombe Society
Harvard College Applied Mathematics Society
Harvard College Association for the Promotion of Interplanetary Expansion (HAPIE)
Harvard College Association for U.S. - China Relations
Harvard College Association of Practice and Learning of Yan Xin Life Science & Technology
Harvard College Baha'i Association
Harvard College Baroque Chamber Orchestra
Harvard College Bhangra
Harvard College Black Pre-Law Association
Harvard College Bowl
Harvard College British Club
Harvard College Candela Latin Dance Troupe
Harvard College Chado Society
Harvard College Chapter: Young Democratic Socialists of America
Harvard College Children's Stories
Harvard College China Forum
Harvard College Chinese International Students Society
Harvard College Coaches
Harvard College Community for Student Researchers
Harvard College Conservation Society
Harvard College Consulting Group
Harvard College Culinary Club
Harvard College Debating Union
Harvard College Deepam
Harvard College Democrats
Harvard College Dutch Society
Harvard College Economics Review
Harvard College Effective Altruism
Harvard College Electronic Music Collective
Harvard College Engineering Society
Harvard College Engineers Without Borders
Harvard College Faith and Action
Harvard College Film Festival
Harvard College Francophone Society
Harvard College French Club
Harvard College Friends of the Red Cross
Harvard College Gap Year Society
Harvard College German Club
Harvard College German Students Association
Harvard College Global Research and Consulting Group
Harvard College Half Asian People's Association
Harvard College Hawaii Club
Harvard College Health Policy Review
Harvard College Healthcare Associates
Harvard College Hellenic Society
Harvard College Human Rights Review
Harvard College iGEM
Harvard College Impact Investing Group
Harvard College in Asia Program
Harvard College Interfaith Forum
Harvard College International Negotiation Program
Harvard College Iranian Association
Harvard College Italian Society
Harvard College Japan Initiative
Harvard College Korean International Student Association
Harvard College Latinos in Health Careers
Harvard College Medical Humanities Forum
Harvard College Meditation Club
Harvard College Mentors for Urban Debate
Harvard College Musical Theater
Harvard College Nigerian Students Association
Harvard College Office of BGLTQ Student Life
Harvard College Open Data Project
Harvard College Opera Society
Harvard College Orientation
Harvard College Overdose Prevention and Education Students (HCOPES)
Harvard College Pakistani Students Association
Harvard College Palestine Solidarity Committee
Harvard College Partners in Health Engage
Harvard College Photography Club
Harvard College Piano Society
Harvard College Polish Society
Harvard College Pre-Veterinary Society
Harvard College Project for Asian and International Relations
Harvard College Project for Justice
Harvard College Queer Students and Allies
Harvard College Refresh Bolivia Student Chapter
Harvard College Reprojustice Action & Dialogue Collective
Harvard College Running Club
Harvard College Science Club for Girls
Harvard College SHADE
Harvard College Social Enterprise Association
Harvard College Social Innovation Collaborative
Harvard College Society for the Cinematic Arts
Harvard College Solar Powered Vehicle Team
Harvard College SoulFood Christian Fellowship
Harvard College South Slavic Society
Harvard College Speak Out Loud
Harvard College Special Olympics
Harvard College Sports Analysis Collective
Harvard College Stand-Up Comic Society
Harvard College Student Chapter of Storywish
Harvard College Student Chapter of the Massachusetts Menstrual Equity
Harvard College Student Data Scientists
Harvard College Student Diabetes Network
Harvard College Student Israel Summit
Harvard College Student Real Estate Club
Harvard College Students fpr the Exploration and Development of Space (SEDS)
Harvard College TEATRO!
Harvard College Tuesday Magazine
Harvard College Turkish Student Association
Harvard College Undergraduate Research Association
Harvard College Ventures
Harvard College Video Game Development Club
Harvard College VISION Global Health Society (VISION)
Harvard College Wine Society
Harvard College Wireless Club
Harvard College Women's Center
Harvard Community Garden
Harvard Community of Humanists, Atheists, and Agnostics
Harvard Composers Association
Harvard Computer Society
Harvard Cricket Club
Harvard Curling Club
Harvard Cycling Club
Harvard Debate Council
Harvard Early Music Society
Harvard Fencing Club
Harvard Field Hockey Club
Harvard Figure Skating Club
Harvard Financial Analysts Club
Harvard Flag Football Club
Harvard Futsal Club
Harvard Glee Club
Harvard Golf Club
Harvard Hapkido Club
Harvard Hillel
Harvard Hong Kong Society
Harvard Independent
Harvard Intercollegiate Model United Nations
Harvard International Relations Council
Harvard International Relations on Campus 
Harvard International Review
Harvard Investment Association
Harvard Islamic Society
Harvard Japan Society
Harvard Jiu Jitsu Club
Harvard Karate Club
Harvard Kendo Club
Harvard Korean Association
Harvard Krav Maga Club
Harvard Lampoon
Harvard Latter-day Saint Student Association
Harvard Library
Harvard Men's Ice Hockey Club
Harvard Men's Lacrosse Club
Harvard Men's Rugby Club
Harvard Men's Soccer Club
Harvard Men's Tennis Club
Harvard Men's Ultimate Frisbee Club
Harvard Men's Volleyball Club
Harvard Mock Trial Association
Harvard Model Congress
Harvard Model Congress Asia
Harvard Model Congress Europe
Harvard Model Congress Middle East
Harvard Model Congress San Francisco
Harvard Model United Nations
Harvard Mountaineering Club
Harvard National Model United Nations
Harvard Opportunes
Harvard Organ Society
Harvard Organization for Latin America
Harvard Outing Club, Inc.
Harvard Philippine Forum
Harvard Political Review
Harvard Polo Club
Harvard Pops Orchestra
Harvard Powerlifting Club
Harvard Pre-Medical Society
Harvard Program for International Education
Harvard Project SWIM Club
Harvard Quidditch Club
Harvard Radio Broadcasting, Inc
Harvard Republican Club
Harvard Reserve Officer Training Corps Association
Harvard Review of Philosophy
Harvard Right to Life
Harvard Romanian Association
Harvard Sailing Club
Harvard Science Review
Harvard Scuba Diving Club
Harvard SEAS National Society of Black Engineers (NSBE)
Harvard SEAS Society of Hispanic Engineers
Harvard SEAS Society of Women Engineers (SWE)
Harvard Shooting Club
Harvard Ski Club
Harvard Society for Mind, Brain, and Behavior
Harvard Society of Arab Students
Harvard Society of Black Scientists and Engineers
Harvard South Asian Association
Harvard Squash Club
Harvard Student Agencies
Harvard Students for Israel
Harvard Swimming Club
Harvard Table Tennis Club
Harvard Taekwondo Club
Harvard Taiwanese Cultural Society
Harvard TAPS
Harvard Undergraduate Aeronautics
Harvard Undergraduate African Policy and Development Initiative
Harvard Undergraduate Alexander Hamilton Society
Harvard Undergraduate Alliance for Syria
Harvard Undergraduate Arab Professional Network
Harvard Undergraduate Art Club
Harvard Undergraduate Art History Society
Harvard Undergraduate Astronomy Society
Harvard Undergraduate Beekeepers
Harvard Undergraduate BGLTQ Business Society (HUBBS)
Harvard Undergraduate Bioethics Society
Harvard Undergraduate Black Community Leaders
Harvard Undergraduate Black Health Advocates
Harvard Undergraduate Black Premedical Society
Harvard Undergraduate Brazilian Association
Harvard Undergraduate Bridge Club
Harvard Undergraduate Capital Partners
Harvard Undergraduate Chapter for RARE
Harvard Undergraduate Chapter of University Blood Initiative
Harvard Undergraduate Christian Fellowship
Harvard Undergraduate Clean Energy Group
Harvard Undergraduate Consulting on Business and the Environment
Harvard Undergraduate Council
Harvard Undergraduate Cybersecurity Club
Harvard Undergraduate Democracy Matters
Harvard Undergraduate Design Collective
Harvard Undergraduate Dominican Student Association
Harvard Undergraduate Economics Association
Harvard Undergraduate Ethics Bowl
Harvard Undergraduate Filmmakers Association
Harvard Undergraduate Fishing Club
Harvard Undergraduate Foreign Policy Initiative
Harvard Undergraduate Global Alliance for Medical Innovation
Harvard Undergraduate Global Education Movement
Harvard Undergraduate Global Health Forum
Harvard Undergraduate Global Surgery
Harvard Undergraduate Global Women's Empowerment
Harvard Undergraduate Group Peer Therapy (HUGPT)
Harvard Undergraduate Health Righters
Harvard Undergraduate Initiative for Technology and Society
Harvard Undergraduate Interdisciplinary Immunology Club
Harvard Undergraduate Journal of Ethics
Harvard Undergraduate Knitting Circle
Harvard Undergraduate KORUM
Harvard Undergraduate Latinxs in Finance & Technology
Harvard Undergraduate Law Review
Harvard Undergraduate Linguistics Society
Harvard Undergraduate Mathematics Association
Harvard Undergraduate Minecraft Club
Harvard Undergraduate Nepali Student Association
Harvard Undergraduate New Mexico Club
Harvard Undergraduate Obstacle Course Racing Club
Harvard Undergraduate Partners for Action in Africa
Harvard Undergraduate Patient Support Corps
Harvard Undergraduate Poker Club
Harvard Undergraduate Political Consulting
Harvard Undergraduate Pre-Dental Society
Harvard Undergraduate PRIMUS
Harvard Undergraduate Psychedelics Club
Harvard Undergraduate Pyschological Association for Underrepresented Students
Harvard Undergraduate Real Estate Investment Group
Harvard Undergraduate Robotics Club
Harvard Undergraduate Rock, Paper, Scissors Club
Harvard Undergraduate Science Olympiad
Harvard Undergraduate Slavic Finance and Technology Association
Harvard Undergraduate Society of Anthropologists
Harvard Undergraduate Songwriters' Collective
Harvard Undergraduate South Asian Americans in Public Service
Harvard Undergraduate Spanish Association
Harvard Undergraduate Spikeball Club
Harvard Undergraduate Student Art Collective
Harvard Undergraduate Students for Myanmar
Harvard Undergraduate Studies in Education
Harvard Undergraduate Surf Club
Harvard Undergraduate Symphony Society
Harvard Undergraduate Synapse Chapter
Harvard Undergraduate Taiwan Leadership Conference
Harvard Undergraduate Task Force for Asian American Progressive Advocacy and Studies
Harvard Undergraduate Technology Review
Harvard Undergraduate Thomas V. Sullivan Society
Harvard Undergraduate Tyro
Harvard Undergraduate UNICEF Club
Harvard Undergraduate Union of Mixed Students
Harvard Undergraduate United Nations Association
Harvard Undergraduate Ventures Capital Group
Harvard Undergraduate Veterans Organization
Harvard Undergraduate Voters Choose
Harvard Undergraduate Women in Business
Harvard Undergraduate Women in Computer Science
Harvard Undergraduate Women in Medicine
Harvard Undergraduate Women's Collective
Harvard Undergraduate World Pre-Health Conference
Harvard Undergraduate.ai
Harvard Undergraduates for Bipartisan Solutions
Harvard Undergraduates for Environmental Justice
Harvard Undergraduates for Inclusion in Economics
Harvard Undergraduates Raising Autism Awareness!
Harvard University Band
Harvard University Choir
Harvard University Health Services
Harvard Vietnamese Association
Harvard Wind Ensemble
Harvard Women's Basketball Club (Women's Hoopsters)
Harvard Women's Ice Hockey Club
Harvard Women's Lacrosse Club
Harvard Women's Soccer Club
Harvard Women's Tennis Club
Harvard Women's Ultimate Frisbee Club
Harvard Women's Volleyball Club
Harvard Women's Wrestling Club
Harvard World Model United Nations
Harvard Yearbook Publications, Inc.
Harvard's Under Construction
Harvard-Radcliffe Asian American Association
Harvard-Radcliffe Asian American Christian Fellowship
Harvard-Radcliffe Asian American Womxn's Association
Harvard-Radcliffe Chinese Students Association
Harvard-Radcliffe Collegium Musicum
Harvard-Radcliffe Dramatic Club
Harvard-Radcliffe Gilbert & Sullivan Players
Harvard-Radcliffe Modern Dance Company
Harvard-Radcliffe Mozart Society Orchestra
Harvard-Radcliffe Orchestra
Harvard-Radcliffe Science Fiction Association
Harvard-Radcliffe Society of Physics Students
Harvard-Radcliffe Veritones
Harvard/Radcliffe RAZA
Hasty Pudding Theatricals
Humans of Harvard College
Hyperion Shakespeare Company
Immediate Gratification Players
Indigo Peer Counseling
Institute of Politics
Khmer Student Association
Kidney Disease Screening and Awareness Program
Kirkland House Committee
La Organizacion de Puertorriquenos en Harvard
Latinas Unidas de Harvard College
Leadership Institute at Harvard College
Leadership Institute for the First-Year Experience
Leverett House Committee
Lowell House Committee
Lowell House Society of Russian Bell Ringers at Harvard College
MakeHarvardCollege
Mariachi Veritas de Harvard
Mather House Committee
Minority Association of Premedical Students (MAPS)
Model Security Council
Music in Hospitals and Nursing Homes Using Entertainment as Therapy
National Society of Black Physicists at Harvard College
Natives at Harvard College
Network of Enlightened Women (NeW) at Harvard College
Noteables
Office of Career Services
Office of Disability Resources
Office of International Education
Omo Naija x The Wahala Boys Dance Troupe
On Harvard Time
On Thin Ice
Organization of Asian American Sisters in Service
Orthodox Christian Fellowship of Harvard College
PALABRITAS
Passus: Harvard College Step Team
PBHA Mission Hill Afterschool Program
PBHA Recreational Experience and Arts Creativity with Harvard
PBHA's 1-2-1 Boston Refugee Youth Enrichment
PBHA's Alternative Spring Breakers
PBHA's Best Buddies
PBHA's Boston Refugee Youth Enrichment Afterschool
PBHA's Boston Refugee Youth Enrichment Extension
PBHA's Boston Refugee Youth Enrichment Summer Program
PBHA's Boston Refugee Youth Enrichment Teen Mentoring
PBHA's Cambridge After-School Program
PBHA's Cambridge Youth Enrichment Program
PBHA's CHANCE
PBHA's Chinatown Adventure
PBHA's Chinatown Afterschool Program
PBHA's Chinatown Big Sibling Program
PBHA's Chinatown Citizenship Program
PBHA's Chinatown ESL Program
PBHA's Chinatown Teen Mentoring
PBHA's CIVICS
PBHA's Connelly Center Youth Prison Tutoring Program
PBHA's David Walker Scholars Program
PBHA's Deaf Awareness Club
PBHA's Elderly 1-2-1
PBHA's Environmental Action Committee
PBHA's Experimentors
PBHA's Franklin After School Enrichment
PBHA's Franklin I-O Summer Program
PBHA's HARMONY Mentoring
PBHA's Harvard Artists for Alzheimer's
PBHA's Harvard College Alzheimer's Buddies Program
PBHA's Harvard College Youth Leadership Initiative
PBHA's Harvard Habitat for Humanity
PBHA's Harvard S.T.A.G.E. - Student Theater Advancing Growth & Empowerment
PBHA's Harvard Small Claims Advisory Service
PBHA's Harvard Square Homeless Shelter
PBHA's Keylatch Afterschool Program
PBHA's Keylatch Mentor Program
PBHA's Keylatch Summer Program
PBHA's Kids with Special Needs Achievement Program
PBHA's LEADERS! Summer Program
PBHA's LEADERS! Term
PBHA's Mission Hill Summer Program
PBHA's Mission Mentor
PBHA's Native American Youth Enrichment Program Summer
PBHA's Partners Empowering Neighborhoods
PBHA's Peer Health Exchange
PBHA's Pets as Therapy
PBHA's Recent Immigrant Term-Time Enrichment
PBHA's Refugee Youth Summer Enrichment
PBHA's Roxbury Youth Initiative Summer
PBHA's Roxbury Youth Initiative Term
PBHA's South Boston Afterschool Program
PBHA's South Boston Outreach Summer
PBHA's Strong Women, Strong Girls
PBHA's Student Labor Action Movement
PBHA's Suffolk Prison Education
PBHA's The Athena Program
PBHA's Undergraduate Legal Committee
PBHA's Women's Empowerment and Prison Education Program
PBHA's Y2Y Harvard Square
PBHA's Youth Recreation Program- HOOPs
Personal Finance & Consulting Group
Pforzheimer House Committee
Phillips Brooks House Association
Phillips Brooks House Center for Public Service & Engaged Scholarship
Project Access: Harvard Undergraduate Chapter
Public Service Network
Quad Sound Studios
Quantum Computing Association
Quincy House Committee
Radcliffe Choral Society
Radcliffe Union of Students
Response
Road to Recovery
Room 13
SACH: Harvard Undergraduate Sikh Student Association
Satire V
Sexual Health Education & Advocacy throughout Harvard College
Singapore, Indonesia and Malaysia Association
Smart Women Securities
Society of Harvard Undergraduate Magicians
South African Society
South Asian Men's Collective
South Asian Music Association
South Asian Women's Collective
STRIVE
Student Astronomers at Harvard-Radcliffe
Student Organizations Center at Hilles
Students of Queer Identities in STEM at Harvard College (SQuISH)
Studio Art Society
Synthesis
TAMID Israel Investment Group
TEDxHarvard College
Tempus: The Harvard College History Review
Texas Club of Harvard
The Aleph
The Concordium
The Cuban-American Undergraduate Student Association
The Fleur-de-Lis Club
The Food Lab for Kids @ Harvard College
The Franklin Fellowship
The Harvard Advocate
The Harvard Callbacks
The Harvard College Armenian Students Association
The Harvard Crimson
The Harvard Din & Tonics
The Harvard Foundation for Intercultural and Race Relations
The Harvard Ichthus
The Harvard Krokodiloes, Inc.
The Harvard LowKeys
The Harvard Undergraduate Drummers (THUD)
The Harvard Undergraduate Research Journal
The Harvard University Jazz Bands
The Ivy
The John Adams Society: A Harvard College Debating Society
The Kali Praxi
The Kuumba Singers of Harvard College
The Lowell House Opera Society
The Oak Club
The Open Online Education Platform, Harvard College Student Chapter
The Radcliffe Pitches
The River Charles Ensemble
The Sab Club
The Salient
The Seneca, Inc.
The Wellness Educators
Themis Asteri
Three Letter Acronym
Under the Surface: The Harvard Undergraduate Mental Health Magazine
Undergraduate Women of Harvard Athletics
United World Club at Harvard College
Veritas Financial Group
Walking Association
Wintersession
Winthrop House Committee
Women in Law Association
Women in Nature Network
Women in STEM at Harvard-Radcliffe
Women of Color Collective
Women's Cabinet
Woodbridge International Society
Writing and Public Service Initiative (WPSI) at Harvard College
Youth Alliance for Leadership and Development in Africa`;

export default clubs;